/**
 * 加载动画组件
 * 
 * 支持多种显示模式：
 * - default: 普通行内加载
 * - fullscreen: 全屏加载
 * - modal: 模态框内加载
 */

import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  /** 显示模式 */
  variant?: 'default' | 'fullscreen' | 'modal'
  /** 加载提示文字 */
  text?: string
  /** 自定义类名 */
  className?: string
}

export const LoadingSpinner = ({ 
  variant = 'default', 
  text = '加载中...',
  className 
}: LoadingSpinnerProps) => {
  // 基础 spinner
  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div 
        className={cn(
          "animate-spin rounded-full border-4 border-[var(--action-blue)] border-t-transparent",
          variant === 'fullscreen' || variant === 'modal' ? 'h-12 w-12' : 'h-8 w-8'
        )}
        role="status"
        aria-label="加载中"
      />
      {text && (
        <p className={cn(
          "text-muted-foreground",
          variant === 'fullscreen' ? 'text-base' : 'text-sm'
        )}>
          {text}
        </p>
      )}
    </div>
  )

  // 全屏模式
  if (variant === 'fullscreen') {
    return (
      <div 
        className={cn(
          "fixed inset-0 z-50 flex items-center justify-center gradient-bg",
          className
        )}
      >
        {spinner}
      </div>
    )
  }

  // 模态框模式
  if (variant === 'modal') {
    return (
      <div 
        className={cn(
          "absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-[var(--panel-white)]/90",
          className
        )}
      >
        {spinner}
      </div>
    )
  }

  // 默认模式
  return (
    <div className={cn("flex items-center justify-center py-8", className)}>
      {spinner}
    </div>
  )
}

export default LoadingSpinner
